<div class="upload-container">
  <div class="col-auto">
  <label for="fileUpload" class="upload-button">
    <i class="fa fa-upload"></i>
    Selecionar arquivo ou tirar foto
  </label>
  </div>

  <input
    #fileInput
    id="fileUpload"
    type="file"
    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
    (change)="onFileSelected($event)"
  />

  <span class="upload-info">
    Formatos aceitos: JPG, PNG, PDF, DOC, DOCX - Máx. 10MB
  </span>

  <span *ngIf="selectedFile" class="file-name">
    {{ selectedFile.name }}
  </span>

  <div>
    <button type="button" class="btn-remove" (click)="removeFile(fileInput)">
      <i class="fa fa-times"></i>
      Remover
    </button>
  </div>

  <span *ngIf="errorMessage" class="upload-error">
    {{ errorMessage }}
  </span>
</div>
